module.exports = __webpack_public_path__ + "static/media/icon-lap-ALL.5c40dfff.svg";